module.exports = __webpack_public_path__ + "img/login2.4f81cd4a.png";